
import { tzFetch, HOST} from "../../../utils/http";

//send OTP
export function cancelFlow (params = {}) {
  return tzFetch(`${HOST}/fapi/gateway/cancel-flow`, params, 'POST');
}